import { render, staticRenderFns } from "./IndexKendoGrid.vue?vue&type=template&id=42c8b986&scoped=true&"
import script from "./IndexKendoGrid.vue?vue&type=script&lang=js&"
export * from "./IndexKendoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8b986",
  null
  
)

export default component.exports